import { render } from "./KoruAddress.vue?vue&type=template&id=03cab1d1&ts=true"
import script from "./KoruAddress.vue?vue&type=script&lang=ts"
export * from "./KoruAddress.vue?vue&type=script&lang=ts"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__